/**
 * Card Quick Add
 * 复用主题已有的：
 *   - fetchConfig()          全局工具函数 (global.js)
 *   - PUB_SUB_EVENTS         事件常量 (pubsub.js / global.js)
 *   - publish()              发布 cartUpdate 事件，cart drawer 自动监听并刷新
 *   - cart.renderContents()  CartDrawer 的方法，渲染内容 + 打开侧边栏
 */
(function () {
  'use strict';

  function bindQuickAddButtons() {
    document.querySelectorAll('.card__quick-add-btn[data-variant-id]').forEach((btn) => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', handleQuickAdd);
    });
  }

  function handleQuickAdd(event) {
    const btn = event.currentTarget;
    if (btn.getAttribute('aria-disabled') === 'true') return;

    // 获取主题的 cart-drawer 或 cart-notification 元素（与 product-form.js 保持一致）
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    // --- Loading 状态（与主题 product-form.js 保持一致）---
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('loading');
    btn.querySelector('.loading__spinner')?.classList.remove('hidden');

    // 使用主题的 fetchConfig()，保持请求头一致
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    // 用 FormData 拼装请求体（与 product-form.js 一致）
    const formData = new FormData();
    formData.append('id', btn.dataset.variantId);
    formData.append('quantity', 1);
    if (cart) {
      // 请求 sections 数据，cart drawer 用于自我刷新
      formData.append('sections', cart.getSectionsToRender().map((s) => s.id).join(','));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(routes.cart_add_url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          // 加购失败（如库存不足）
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'card-quick-add',
            productVariantId: btn.dataset.variantId,
            errors: response.errors || response.description,
            message: response.message,
          });
          return;
        }

        if (!cart) {
          // 无购物车组件时，跳转到购物车页
          window.location = window.routes.cart_url;
          return;
        }

        // 触发主题的 cartUpdate 事件（让 cart icon bubble 等订阅者自动更新）
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'card-quick-add',
          productVariantId: btn.dataset.variantId,
          cartData: response,
        });

        // 调用主题 CartDrawer.renderContents()，渲染 drawer 内容并自动打开侧边栏
        cart.renderContents(response);
      })
      .catch((e) => {
        console.error('[Card Quick Add]', e);
      })
      .finally(() => {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
        btn.querySelector('.loading__spinner')?.classList.add('hidden');
        if (cart?.classList.contains('is-empty')) cart.classList.remove('is-empty');
      });
  }

  // 初始化
  bindQuickAddButtons();

  // 监听动态插入的卡片（infinite scroll 等）
  new MutationObserver(bindQuickAddButtons).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
